import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faSearch,
  faHome,
  faAngleDoubleUp,
  faArrowRight,
  faArrowLeft,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowsAlt,
  faCalendarAlt,
  faCalendarDay,
  faClock,
  faFileDownload,
  faMapMarkerAlt,
  faRedo,
  faFlag,
  faUser,
  faTag,
  faFolderOpen,
} from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faTwitter,
  faFacebookF,
  faInstagram,
  faBluesky,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

config.autoReplaceSvg = true;
library.add(
  faBars,
  faSearch,
  faHome,
  faAngleDoubleUp,
  faArrowRight,
  faArrowLeft,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowsAlt,
  faCalendarAlt,
  faCalendarDay,
  faClock,
  faFileDownload,
  faMapMarkerAlt,
  faRedo,
  faFlag,
  faUser,
  faTag,
  faFolderOpen,
  faYoutube,
  faTwitter,
  faFacebookF,
  faInstagram,
  faBluesky,
  faLinkedin,
);
dom.i2svg();
